import { configureStore } from '@reduxjs/toolkit';
import deviceDashboardReducer from '../reducers/deviceDashboard';

export default configureStore({
  reducer: {
    deviceDashboard: deviceDashboardReducer,
  },
});
